import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';

import { Button, Image, Section, Specifications } from '@boss/ui';

import { LoginSectionProps } from '..';
import { useLogin } from '../../../hooks';

const LoginSectionSecondary = ({ bannerImage }: LoginSectionProps) => {
  const { t } = useTranslation('login');
  const { handleRegister } = useLogin();
  const { asPath } = useRouter();

  return (
    <Section
      className="flex flex-col gap-4 lg:gap-6"
      content={
        <>
          <span className="h2 lg:max-w-1/2">{t('title')}</span>
          <div className="grid gap-6 lg:grid-cols-3">
            <div className="relative h-auto lg:col-span-2 lg:h-full lg:min-h-80">
              {bannerImage?.fields?.file?.url && (
                <Image
                  alt="login-banner-BOSS-paints"
                  className="rounded-image object-left"
                  fill
                  focalpoint="left"
                  src={bannerImage.fields?.file?.url}
                  wrapperClassName="self-stretch h-full"
                />
              )}
            </div>

            <div className="bg-green-dark flex flex-col justify-center gap-3 px-6 py-8 lg:gap-6 lg:p-8" data-card>
              <Specifications
                border={false}
                className="gap-4"
                iconClassName="text-white pt-0"
                items={[1, 2, 3, 4].map(item => (
                  <span className="text-white" key={`client-benefit-${item}`}>
                    <Trans
                      components={{ strong: <strong className="font-bold" /> }}
                      i18nKey={`newClientCard.benefits.${item}`}
                      ns="login"
                    />
                  </span>
                ))}
                liClassName="gap-3.5"
              />
              <div className="flex flex-col gap-3">
                <Button
                  className="justify-center text-center [&>*]:w-auto"
                  icon={faAngleRight}
                  iconPosition="right"
                  label={t('newClientCard.footerLink')}
                  onClick={() => handleRegister(asPath)}
                  type="primary"
                />
              </div>
            </div>
          </div>
        </>
      }
    />
  );
};

export default LoginSectionSecondary;
